import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, onUnmounted, computed, reactive } from "vue";
import { useRoute, useRouter } from "vue-router"
import { Toast } from "vant"
import { cheackQuery, pickQueryParam, nativeToLogin, ToBack } from "@/uitls/native";
import { useI18n } from "vue-i18n";
import { userLookOrSend } from "@/api/php/player";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";
import { addQueryParams, formatDate } from "@/uitls/uitls";
import EventBus from "@/uitls/EventBus";
import { Storage } from "@/uitls/Storage";
import Platform from "@/config/platform";
import SpinPointerComponent from "@/views/me/SpinPointerComponent.vue"
import PrizeResultModal from "@/views/me/PrizeResultModal.vue"
import {
    encryptionGuessListInfo,
    encryptionGuessJoin
} from "@/api/php/me";

import { load } from "protobufjs";


export default /*#__PURE__*/_defineComponent({
  name: 'PointGuessingActive',
  setup(__props, { expose }) {
  expose();

const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const showTopBar = ref(true);
const guessing_bg_icon = require("@/assets/images/pointGuessing_bg.png");
//活动规则
const rule_html = ref("");
const rule_title = ref("");
//比赛列表
const MatchList = ref([]);
// 当前用户积分
const points = ref(0);
// van-list 控制：是否正在加载下一页
const loading = ref(false);
// van-list 控制：是否已经加载完所有数据
const finished = ref(true);
const refreshing = ref(false);
const showBetAlertView = ref(false);
const showRuleAlertView = ref(false);
const pointSelectIndex = ref(-1);

const left_nor = require("@/assets/images/guess_left_nor.png");
const left_sel = require("@/assets/images/guess_left_sel.png");
const middle_nor = require("@/assets/images/guess_middle_nor.png");
const middle_sel = require("@/assets/images/guess_middle_sel.png");
const right_nor = require("@/assets/images/guess_right_nor.png");
const right_sel = require("@/assets/images/guess_right_sel.png");
const bask_left_nor = require("@/assets/images/bask_left_nor.png");
const bask_left_sel = require("@/assets/images/bask_left_sel.png");
const bask_right_nor = require("@/assets/images/bask_right_nor.png");
const bask_right_sel = require("@/assets/images/bask_right_sel.png");

const pointArr = ref([]);
const matcheList = ref([]);
const selectOddsType = ref("");
const selectId = ref('');
const selectPoint = ref(0);

onMounted(async () => {

    
    let os = pickQueryParam(route, 'os');
    const token = pickQueryParam(route, 'token');
    if (os && os != "h5") {
        if (token == undefined || token == "" || token == "0") {
            await router.replace({
                path: route.path,
                query: {}           // 空对象 → URL 里不再有 ? 后面任何参数
            });
            os = 'h5';
            Storage.clear();
        }
    }
    cheackQuery(route);

    const fid = pickQueryParam(route, 'fid');
    const uid = pickQueryParam(route, 'uid');
    const fastkey = pickQueryParam(route, 'fastkey');
    const channel = pickQueryParam(route, 'channel');
    const customerId = pickQueryParam(route, 'customerId');


    const loading = Toast.loading({
        message: "loading...",
        forbidClick: false,
        loadingType: 'spinner',
        duration: 0
    });
    if (os && os != "h5") {
        //app端跳入
        if (token == undefined || token == "" || token == "0") {
            //弹窗登录
            EventBus.emit('showLogin', { refresh: true });

        } else {
            isYk.value = false;
            Storage.set('fid', fid);
            Storage.set('token', token);
            user.value.token = token;
            Storage.set('uid', uid);
            Storage.set('fastkey', fastkey);
            Storage.set('customerId', customerId);
            Platform.channel = Number(channel);
            console.log('channel', channel);
        }
    } else {

        showTopBar.value = true;
        console.log(user.value.token);
        await toLogin();
        if (isYk.value) {
            EventBus.emit('showLogin', { refresh: true });
        }
    }

    await requestMatchList();
    loading.clear();
});

onUnmounted(() =>{
    EventBus.off("phpLoginSuccessNotification");
})

EventBus.on("phpLoginSuccessNotification", () => {
    //登录成功，再去获取用户积分数据
    requestMatchList();
});

const checkShowLogin = () => {
    if (user.value.token && user.value.token.length > 0) {
        return true;
    } else {
        EventBus.emit('showLogin', { refresh: true });
        return false;
    }
}

const requestMatchList = async() => {
    
    const res:any = await encryptionGuessListInfo();
    if(res.code == 200){
        rule_html.value = res.data.guess_html_rule;
        rule_title.value = res.data.guess_title;
        points.value = res.data.score;
        matcheList.value = res.data.list;
        pointArr.value = res.data.guess_score;
         
        for(let item of matcheList.value){
            if(!item.order){
                item.order = {};
            }
        }
    }else{
       Toast({ message: res.msg, type: 'fail' });
    }
}

onUnmounted(() => {
    Toast.clear();
});

// 点击整行 van-cell（示例中无跳转逻辑，可根据需求修改）
function onMatchClick(match) {
    // 无操作，仅示例
}

// 选中某个选项：'odds_win' | 'odds_draw' | 'odds_loss'
function selectOption(item, type) {

    if(!checkShowLogin()){
        return;
    }

    // item.selected = type;
    selectId.value = item.id;
    selectOddsType.value = type; 
    showBetAlertView.value = true;
}

// van-list 滚动到底部时触发（本例不做分页，仅示例）
function onLoad() {
    loading.value = false;
    finished.value = true;
}

const ruleAction = () => {
    showRuleAlertView.value = true;
}

//竞猜记录
const guessRecord = () => {
    if(checkShowLogin()){
        router.push("/pointGuessingRecord");
    }
}

//下拉刷新
const onRefresh = async() => {
    matcheList.value = [];
    await requestMatchList();
    refreshing.value = false;
}

//确认下注
const comfirmGuessAction = async () => {
    
    if(selectPoint.value <1){
        return;
    }
    if(points.value < selectPoint.value){
        Toast({ message: t('投注失败，积分不足'), type: 'fail' });
        return;
    }
    const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: 'loading...',
    });
    const res:any = await encryptionGuessJoin({
        odds_type: selectOddsType.value,
        score: selectPoint.value,
        id: selectId.value
    });
    if(res.code == 200){
        toast.clear();
        Toast({ message: t('下注成功'), type: 'success' });
        showBetAlertView.value = false;
        requestMatchList();
        // points.value -= selectPoint.value;
        
    }else{
        toast.clear();
        Toast({ message: res.msg, type: 'fail' });
        
    }
}

const pointSelectAction = (index) => {
    pointSelectIndex.value = index;
    selectPoint.value = pointArr.value[index];
}


const __returned__ = { piniaStore, user, isYk, toLogin, t, router, route, showTopBar, guessing_bg_icon, rule_html, rule_title, MatchList, points, loading, finished, refreshing, showBetAlertView, showRuleAlertView, pointSelectIndex, left_nor, left_sel, middle_nor, middle_sel, right_nor, right_sel, bask_left_nor, bask_left_sel, bask_right_nor, bask_right_sel, pointArr, matcheList, selectOddsType, selectId, selectPoint, checkShowLogin, requestMatchList, onMatchClick, selectOption, onLoad, ruleAction, guessRecord, onRefresh, comfirmGuessAction, pointSelectAction, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})